import React, { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { UserLogin } from 'src/services';
import { setUserInfo } from 'src/store/user/action';
import { useDispatch } from 'react-redux';
const initialState = {
  user: null,
  isInitialised: false,
  isAuthenticated: false,
  userType: 'admin'
};

// const isValidToken = (accessToken) => {
//   if (!accessToken) return false;

//   const decodedToken = jwtDecode(accessToken);
//   const currentTime = Date.now() / 1000;
//   return decodedToken.exp > currentTime;
// };


const setSession = (accessToken, accessUser) => {
  return new Promise((resolve) => {
    if (accessToken) {
      localStorage.setItem('@accessToken', accessToken);
      localStorage.setItem('@accessUser', accessUser);
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
      localStorage.removeItem('@accessToken');
      localStorage.removeItem('@accessUser');
      delete axios.defaults.headers.common.Authorization;
    }
    resolve();
  });
};


const reducer = (state, action) => {
  switch (action.type) {
    case 'INIT': {
      const { isAuthenticated, user } = action.payload;
      const userType = user?.role === 'employee' || user?.isEmployee ? 'employee' : 'admin';
      return { ...state, isAuthenticated, isInitialised: true, user, userType };
    }
    case 'LOGIN': {
      const { user } = action.payload;
      const userType = user?.role === 'employee' || user?.isEmployee ? 'employee' : 'admin';
      return { ...state, isAuthenticated: true, user, userType };
    }
    case 'LOGOUT': {
      return { ...state, isAuthenticated: false, user: null, userType: 'admin' };
    }
    case 'REGISTER': {
      const { user } = action.payload;
      const userType = user?.role === 'employee' || user?.isEmployee ? 'employee' : 'admin';
      return { ...state, isAuthenticated: true, user, userType };
    }

    default:
      return state;
  }
};

const AuthContext = createContext({
  ...initialState,
  method: 'JWT',
  login: () => { },
  logout: () => { },
  register: () => { },
  checklogin: () => { },
  loginEmploye: () => { }

});

const normalizeUser = (user) => ({
  ...user,
  image: user?.image || user?.avatar || user?.photo || null,
  firstname: user?.firstname || user?.name,
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const dispatchM = useDispatch();
  const login = async (email, password) => {
    try {
      const response = await UserLogin.UserLogin({ email, password });
      if (response) {
        const fullUserData = normalizeUser({
          ...response.user,
          name: response.user?.firstname,
          lastname: response.user?.lastname,
          image: response.user?.image || response.additionalData?.image,
        });

        await Promise.all([
          setSession(response.token, JSON.stringify(fullUserData)),
          dispatch({ type: 'LOGIN', payload: { user: fullUserData } })
        ]);
        document.body.classList.remove('employee-mode');
        return true;
      } else {
        setSession();
        return false;
      }
    } catch (error) {
      console.error('Login failed:', error);
      setSession();
      return false;
    }

  };
  const loginEmploye = async (email, password) => {
    try {
      const response = await UserLogin.UserLoginEmploye({ email, password });

      if (!response?.user) return false;

      const fullUserData = normalizeUser({
        ...response.user
      });

      await setSession(response.token, JSON.stringify(fullUserData));

      dispatch({ type: 'LOGIN', payload: { user: fullUserData } });

      dispatchM(setUserInfo(fullUserData));

      document.body.classList.add('employee-mode');

      return true;
    } catch (error) {
      console.error('Login failed:', error);
      setSession();
      return false;
    }
  };
  const register = async (email, username, password) => {
    const response = await axios.post('/api/auth/register', { email, username, password });
    const { user } = response.data;

    dispatch({ type: 'REGISTER', payload: { user } });
  };

  const logout = () => {
    setSession()
    document.body.classList.remove('employee-mode');
    dispatch({ type: 'LOGOUT' });
  };
  const checklogin = () => {
    const accessToken = localStorage.getItem('@accessToken');
    if (accessToken) {
      try {
        const raw = localStorage.getItem('@accessUser');
        const userData = raw ? JSON.parse(raw) : null;
        if (userData) {
          dispatch({ type: 'INIT', payload: { isAuthenticated: true, user: userData } });
          return true
        } else {
          console.error('User data not found in localStorage');
          dispatch({ type: 'INIT', payload: { isAuthenticated: false, user: null } });
          return false
        }
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
        dispatch({ type: 'INIT', payload: { isAuthenticated: false, user: null } });
        return false
      }
    } else {
      dispatch({ type: 'INIT', payload: { isAuthenticated: false, user: null } });
      return false
    }
  }
  useEffect(() => {
    (async () => {
      const accessToken = localStorage.getItem('@accessToken');
      if (accessToken) {
        try {
          const raw = localStorage.getItem('@accessUser');
          const userData = raw ? JSON.parse(raw) : null;
          if (userData) {
            dispatch({ type: 'INIT', payload: { isAuthenticated: true, user: userData } });
            // Apply mode according to the user type
            if (userData.role === 'employee' || userData.isEmployee) {
              document.body.classList.add('employee-mode');
            } else {
              document.body.classList.remove('employee-mode');
            }
          } else {
            console.error('User data not found in localStorage');
            dispatch({ type: 'INIT', payload: { isAuthenticated: false, user: null } });
          }
        } catch (error) {
          console.error('Error parsing user data from localStorage:', error);
          dispatch({ type: 'INIT', payload: { isAuthenticated: false, user: null } });
        }
      } else {
        dispatch({ type: 'INIT', payload: { isAuthenticated: false, user: null } });
      }
    })();
  }, []);
  // SHOW LOADER
  if (!state.isInitialised) return <p>hee</p>;

  return (
    <AuthContext.Provider value={{ ...state, method: 'JWT', login, logout, register, checklogin, loginEmploye }}>
      {children}
    </AuthContext.Provider>
  );
};
AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContext;
